import { phonePattern } from "../model/system/constants";

export const isValidPhone = (phone: string): boolean => {
  // noinspection RegExpSimplifiable
  const regExpPattern = new RegExp(
    "\\" +
      phonePattern
        .replace(/[_]/g, "\\d")
        .replace("(", "\\(")
        .replace(")", "\\)"),
  );

  return phone.match(regExpPattern) !== null;
};
